module.exports = __webpack_public_path__ + "static/media/shirt_folded.976c7326.svg";